/**
 * Created by griga on 7/11/16.
 */


import {Routes, RouterModule} from '@angular/router';
import {MainLayoutComponent} from './shared/layout/app-layouts/main-layout.component';
import {AuthLayoutComponent} from './shared/layout/app-layouts/auth-layout.component';
import {ModuleWithProviders} from '@angular/core';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '', redirectTo: 'dashboard', pathMatch: 'full'
            },
            {
                path: 'home',
                loadChildren: 'app/+home/home.module#HomeModule'
            },
            {
                path: 'dashboard',
                loadChildren: 'app/+dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'cita',
                loadChildren: 'app/+cita/cita.module#CitaModule',
                data: {pageTitle: 'Registro de Citas'}
            },
            {
                path: 'recepcion',
                loadChildren: 'app/+recepcion/recepcion.module#RecepcionModule',
                data: {pageTitle: 'Recepción'}
              },
            {
                path: 'ordenservicio',
                loadChildren: 'app/+orden-servicio/orden-servicio.module#OrdenServicioModule',
                data: {pageTitle: 'Orden Servicio'}
            },
            {
                path: 'valuacion',
                loadChildren: 'app/+valuacion/valuacion.module#ValuacionModule',
                data: {pageTitle: 'Valuación de Daños'}
            },
            {
                path: 'cotizacion',
                loadChildren: 'app/+cotizacion/cotizacion.module#CotizacionModule',
                data: {pageTitle: 'Cotización de Daños'}
            },
            {
                path: 'presupuesto',
                loadChildren: 'app/+presupuesto/presupuesto.module#PresupuestoModule',
                data: {pageTitle: 'Presupuesto'}
            },
            {
                path: 'autorizacion',
                loadChildren: 'app/+autorizacion/autorizacion.module#AutorizacionModule',
                data: {pageTitle: 'Autorización de Presupuesto'}
            },
            {
                path: 'plantrabajo',
                loadChildren: 'app/+plan-trabajo/plan-trabajo.module#PlanTrabajoModule',
                data: {pageTitle: 'Plan de Trabajo'}
            },
            {
                path: 'reparacion',
                loadChildren: 'app/+reparacion/reparacion.module#ReparacionModule',
                data: {pageTitle: 'Reparacion de Unidad'}
            },
            {
                path: 'terminada',
                loadChildren: 'app/+terminada/terminada.module#TerminadaModule',
                data: {pageTitle: 'Unidad Terminada'}
            },
            {
                path: 'entrega',
                loadChildren: 'app/+entrega/entrega.module#EntregaModule',
                data: {pageTitle: 'Entrega de Unidad'}
            },
            {
                path: 'refacciones',
                loadChildren: 'app/+compras/compras.module#ComprasModule',
                data: {pageTitle: 'Refacciones'}
            },
            {
                path: 'almacen',
                loadChildren: 'app/+almacen/almacen.module#AlmacenModule',
                data: {pageTitle: 'Módulo de Almacén'}
            },
            {
                path: 'pago',
                loadChildren: 'app/+pago/pago.module#PagoModule',
                data: {pageTitle: 'Pagos'}
            },
            {
                path: 'facturacion',
                loadChildren: 'app/+facturacion/facturacion.module#FacturacionModule',
                data: {pageTitle: 'Facturación'}
            },
            {
                path: 'catalogo',
                loadChildren: 'app/+catalogo/catalogo.module#CatalogoModule',
                data: {pageTitle: 'Catálogos'}
            },
            {
                path: 'administracion',
                loadChildren: 'app/+administracion/administracion.module#AdministracionModule',
                data: {pageTitle: 'Administración'}
            },
            {
                path: 'password',
                loadChildren: 'app/+password/password.module#PasswordModule',
                data: {pageTitle: 'Cambio de Password'}
            },
            {
                path: 'reportes',
                loadChildren: 'app/+reportes/reportes.module#ReportesModule',
                data: {pageTitle: 'Reportes'}
            },
            {
                path: 'inventario',
                loadChildren: 'app/+inventario/inventario.module#InventarioModule',
                data: {pageTitle: 'Inventario'}
            },
            {
                path: 'existencias',
                loadChildren: 'app/+existencias/existencias.module#ExistenciasModule',
                data: {pageTitle: 'Existencias'}
            }
        ]
    },

    {path: 'auth', component: AuthLayoutComponent, loadChildren: 'app/+auth/auth.module#AuthModule'},

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/app.routing.ts